var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c('div',{staticClass:"d-flex"},[(!_vm.isOnlyCart)?_c('navbar-icon-notify'):_vm._e()],1):_c('div',{staticClass:"empty ml-lg-2"})}
var staticRenderFns = []

export { render, staticRenderFns }